import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Select from '../../components/Select';

const Selects = () => (
  <React.Fragment>
    <Row className="styles-section" id="selects">
      <Col xs={12}>
        <h3>Selects</h3>
      </Col>
      <Col xs={12}>
        <Select className="mb-2"
          placeholder={<b>Select Button</b>}
          onChange={(val, meta) => console.log(val, meta)}
          defaultValue={{ label: 'Another action', value: 'action-2' }}
          options={[
            { label: 'Action', value: 'action-1' },
            { label: 'Another action', value: 'action-2' },
            { label: 'Something else', value: 'action-3' },
            { label: 'Separated link', value: 'action-4' },
          ]}
        />
      </Col>

      <Col xs={12}>
        <Select className="mb-2"
          error
          placeholder="Select Button"
          options={[
            { label: 'Action', value: 'action-1' },
            { label: 'Another action', value: 'action-2' },
            { label: 'Something else', value: 'action-3' },
            { label: 'Separated link', value: 'action-4' },
          ]}
        />
      </Col>

      <Col xs={12}>
        <Select className="mb-2"
          isMulti
          placeholder="Select Button"
          options={[
            { label: 'Action', value: 'action-1' },
            { label: 'Another action', value: 'action-2' },
            { label: 'Something else', value: 'action-3' },
            { label: 'Separated link', value: 'action-4' },
          ]}
        />
      </Col>
    </Row>
  </React.Fragment>
);

export default Selects;